import { create, tsx } from '@dojo/framework/core/vdom';
import { ContentWrapper } from '../widgets/ContentWrapper';
import { Hero } from '../widgets/Hero';
import { Link } from '@dojo/framework/routing/Link';
import { Text } from '../widgets/Text';

import * as css from './Error404.m.css';
import Section from '../widgets/Section';

const factory = create();

export const Error404 = factory(function Error404() {
	return (
		<virtual>
			<head>
				<title>Page not found | SitePen</title>
				<meta name="robots" content="noindex, follow" />
				<meta property="og:locale" content="en_US" />
				<meta property="og:title" content="Page not found | SitePen" />
				<meta property="og:site_name" content="SitePen" />
			</head>

			<Hero background="level2RedOrange" align="center" paddingBottom="sm">
				{{
					title: 'Error 404',
					xlTitle: `Page Not Found`,
					blurb: (
						<form action="/blog/search" method="get" classes={css.searchInputWrapper}>
							<input
								id="term"
								name="term"
								classes={css.searchInput}
								type="search"
								placeholder="Search our blogs…"
							/>
							<i title="search" classes={[css.searchIcon, 'icon-search']}></i>
						</form>
					)
				}}
			</Hero>

			<Section type="leading">
				<section classes={css.otherPages}>
					<ContentWrapper>
						<Text type="section">Please try another page...</Text>
						<ul classes={css.pageList}>
							<li>
								<Link classes={css.pageItem} to="services">
									What We Do
								</Link>
							</li>
							<li>
								<Link classes={css.pageItem} to="work">
									Our Work
								</Link>
							</li>
							<li>
								<Link classes={css.pageItem} to="blog">
									Blog
								</Link>
							</li>
							<li>
								<Link classes={css.pageItem} to="contact">
									Contact
								</Link>
							</li>
						</ul>
					</ContentWrapper>
				</section>
			</Section>
		</virtual>
	);
});

export default Error404;
